
import { Component, Vue } from 'vue-property-decorator';
import VueSlickCarousel from 'vue-slick-carousel';

type ContactLink = {
	linkUrl: string;
	altText: string;
	imageUrl: string;
};

@Component({
	components: { VueSlickCarousel }
})
export default class LogosCarousel extends Vue {
	settings = {
		arrows: true,
		dots: false,
		autoplay: true,
		variableWidth: true,
		rows: 1,
		speed: 500,
		slidesToScroll: 2,
		pauseOnFocus: true,
		pauseOnHover: true,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToScroll: 1
				}
			}
		]
	};
}
